<template>
    <div class="modal-edicao mb-3 modal-edicao-label mt-6">
		<EditCustomer
			v-if="modalCustomer"
			:customerData="{}"
			@closeModal="closeCustomer"
			@newCustomer="setCustomer"
			:name="nameCustomer"
		/>
		<EditCategoryExpenses
			v-if="modalCategory"
			:categoryExpenseData="{}"
			@closeModal="closeCategory"
			@newCategoryExpense="setCategory"
			:name="nameCategory"
		/>
        <b-row class="filters-orientation">
			<b-col v-if="!editing && !hideRecurring" cols="2" class="text-parcela" style="text-align: center;">
				<label class="label-conta mb-0">Recurrente</label>
				<div class="toggle-div mr-3" style="width: 100%; align-items: center; margin-top: -4px !important;">
					<ToggleSwitch
						name="isSchedulingRecurring"
						class="toggle"
						:value="isSchedulingRecurring"
						@toggle="_ => changeToggle('isSchedulingRecurring')"
					/>
				</div>
			</b-col>
            <b-col class="text-parcela">
				<label v-if="isSchedulingRecurring" class="label-parcela">Data Inicial</label>
                <label v-else class="label-parcela">Data Lançamento</label>
                <div class="d-flex">
                    <datepicker
						name="createDate"
                        class="w-100"
                        placeholder=""
                        id="data-lancamento"
                        input-class="bg-white"
                        v-model="toReceive_date"
                        :format="formatter"
                        :language="ptBR"
                        :bootstrap-styling="true"
                        data-cy="Data Lançamento"
						:disabled="loading || (isSchedulingRecurring && editing)"
                    />
                </div>
            </b-col>
            <b-col v-if="!multiEdit" class="text-parcela">
				<label v-if="isSchedulingRecurring" class="label-parcela">Data Final</label>
                <label v-else class="label-parcela">Data Vencimento</label>
                <div class="d-flex">
                    <datepicker
						name="expireDate"
                        class="w-100"
                        placeholder=""
                        id="data-lancamento"
                        input-class="bg-white"
                        v-model="toReceive_date_receive"
                        :format="formatter"
                        :language="ptBR"
                        :bootstrap-styling="true"
                        data-cy="Data Recebimento"
						:disabled="loading && !isSchedulingRecurring"
						:value-as-date="false"
						:disabled-dates="disabledEndDates"
                    />
					<div
						v-if="isSchedulingRecurring"
						class="filter icon-delete"
						v-bind:class="!toReceive_date_receive ? 'filter-disable' : ''"
						@click="clearData('toReceive_date_receive')"
						:title="toReceive_date_receive ? 'Limpar' : ''"
					>
						<Trash2Icon/>
					</div>
                </div>
            </b-col>
		</b-row>
		<b-row class="filters-orientation">
            <b-col class="d-block text-parcela">
                <span class="label-conta">
                    Cliente
                </span>
				<SearchSelect
					:key="'customer'"
					name="customer"
					:options="customer.filter(item => !item.inactive)"
					:visibleSuggestion="visibleSuggestion.customer"
					:isMobile="isMobile"
					:newRecord="newCustomer"
					:clearSelect="clearSelect"
					@changeSelect="changeSelect"
					@handleSuggestion="handleVisibleSuggestion"
					@invalidSearch="validateOptionSearch"
				/>
            </b-col>
            <b-col class="text-parcela">
                <span class="label-conta">
                    Categoria
                </span>
				<SearchSelect
					:key="'category'"
					name="category"
					:options="category.filter(item => !item.inactive && item.income)"
					:visibleSuggestion="visibleSuggestion.category"
					:isMobile="isMobile"
					:newRecord="newCategory"
					:clearSelect="clearSelect"
					@changeSelect="changeSelect"
					@handleSuggestion="handleVisibleSuggestion"
					@invalidSearch="validateOptionSearch"
				/>
            </b-col>
        </b-row>
        <Installment v-if="!multiEdit && !isSchedulingRecurring"
            :editing="editing"
            :date="editing ? toReceive_date_receive : toReceive_date"
            @setNewValue="setNewAmount"
            @dataInstallments="setNewToReceiveDataInstallments"
            :update="updateInstallments"
            @errorInstallments="validateInstallments"
            :totalAmount="parseFloat(toReceive_amount)"
            :sendLatePaymentMessage="toReceive_sendLatePaymentMessage"
            :clearFields="clearFields"
        />
		<InstallmentsEdit v-else-if="!isSchedulingRecurring"
			:dataEdit="editRows"
			@invalidData="validateInstallments"
			@dataEditInstallments="setDataMultiEdit"
			:sendLatePaymentMessage="toReceive_sendLatePaymentMessage"
		/>
		<div v-else>
			<SchedulingRecurring
				@data="setDataRecurrent"
				@error="validateInstallments"
				:clearFields="clearFields"
				:disabled="saving || loading"
				:strAmount="editing ? toReceive_amount : '0'"
				:intervalEdit="transactionDocument.interval ? transactionDocument.interval.toString() : null"
				:dayOfWeekEdit="transactionDocument.dayOfWeek ? transactionDocument.dayOfWeek.toString() : null"
				:selectedFrequencyEdit="transactionDocument.frequency || null"
				:dayOfMonthEdit="transactionDocument.dayOfMonth ? transactionDocument.dayOfMonth.toString() : null"
			/>
		</div>
        <b-row class="mt-4 filters-orientation">
            <b-col class="d-block text-parcela">
				<span v-if="isSchedulingRecurring" class="label-conta">Descrição</span>
                <span v-else class="label-conta">Observações</span>
                <b-form-input
                    name="comments"
                    class="modal-edicao-input"
                    v-model="toReceive_comments"
                    autocomplete="off"
                    placeholder=""
                    v-validate="'maxLength:255'"
                    :state="validateState('comments')"
                />
            </b-col>
        </b-row>
    </div>
</template>

<script>
	import dayjs from "dayjs";
	import "dayjs/locale/pt-br";
	import Datepicker from "vuejs-datepicker";
	import { ptBR } from "vuejs-datepicker/dist/locale";
	import { hasFieldsWithErrors } from "@/helpers/validators";
	import { possuiPermissao } from "../../helpers/permissions";
	import { numberFormatted, stringToNumber, validateNumber, isNullValue, formatterSimple, removeAccents } from "@/helpers/common";
	import { ToReceiveService } from "../../services/toReceive";
	import Installment from "@/components/Installment.vue";
	import { mapState } from "vuex";
	import EditCustomer from "@/views/Customer/EditCustomer.vue";
	import EditCategoryExpenses from "@/views/CategoryExpenses/EditCategoryExpenses.vue";
	import SearchSelect from "@/components/SearchSelect.vue";
	import InstallmentsEdit from "@/components/InstallmentsEdit.vue";
	import { SchedulingRecurringService } from "../../services/schedulingRecurring";
	import ToggleSwitch from "@/components/ToggleSwitch.vue";
	import SchedulingRecurring from "@/components/SchedulingRecurring.vue";

	import "./styles.css";

	export default {
		name: "FormToReceive",
		components: {
			Datepicker,
			Installment,
			EditCustomer,
			EditCategoryExpenses,
			SearchSelect,
			InstallmentsEdit,
			ToggleSwitch,
			SchedulingRecurring
		},

		props: {
			transactionDocument: {
				type: Object,
				required: true
			},
			toSave: {
				type: Boolean,
				required: true
			},
			clearFields: {
				type: Boolean,
				required: true
			},
			isMobile: {
				type: Boolean,
				required: false
			}
		},
		data () {
			return {
				possuiPermissao,
				ready: true,
				loading: false,
				ptBR,

				editRows: [],
				originalRows: [],

				toReceive_idToReceive: null,
				toReceive_comments: "",
				toReceive_idCategory: null,
				toReceive_idCustomer: null,
				toReceive_date: new Date(),
				toReceive_date_receive: new Date(),
				toReceive_sendLatePaymentMessage: false,
				toReceive_idToReceiveDocument: null,

				toReceive_amount: 0,
				toReceive_amount_string: "0,00",

				toReceivePayloadObject: {},

				multiEdit: false,
				updateInstallments: true,
				errorInstallments: true,

				editing: false,
				saving: false,
				invalidForm: true,
				toReceiveService: new ToReceiveService(),
				disableAmount: false,

				customerOptions: [],
				categoryOptions: [],
				modalCustomer: false,
				modalCategory: false,
				visibleSuggestion: {
					customer: false,
					category: false
				},
				nameCustomer: "",
				nameCategory: "",
				invalidSearch: {
					customer: true,
					category: true
				},
				newCategory: {},
				newCustomer: {},
				clearSelect: false,

				isSchedulingRecurring: false,
				toReceive_idSchedulingRecurring: null,
				schedulingRecurringService: new SchedulingRecurringService(),
				hideRecurring: false,
				disabledEndDates: {}
			};
		},

		watch: {
			toSave () {
				if (this.toSave) this.save();
			},
			clearFields () {
				if (this.clearFields) this.clearModal();
			}
		},

		computed: mapState(["customer", "category"]),

		async mounted () {
			const today = new Date();
			this.disabledEndDates = {
				to: new Date(today.getTime() - 1)
			};

			if (this.transactionDocument.idSchedulingRecurring) {
				this.hideRecurring = true;
				this.isSchedulingRecurring = true;
			}

			if (this.transactionDocument.idToReceive || this.transactionDocument.idSchedulingRecurring) {
				if (this.transactionDocument.UUID && this.transactionDocument.installments > 1) {
					const filters = {
						UUID: this.transactionDocument.UUID,
						status: "Em aberto"
					};
					const result = await this.toReceiveService.getToReceiveInstallmentsActive(filters) || {};

					this.editRows = result.rows.reduce((acc, c) => [
						...acc,
						{
							idToReceive: c.idToReceive,
							paymentDate: formatterSimple(c.toReceiveDate),
							fullDate: c.toReceiveDate,
							amount: numberFormatted(c.amount).replace(".", ""),
							reference: c.reference || "",
							comments: c.comments,
							idCustomer: c.idCustomer,
							idCategoryExpense: c.idCategory,
							date: c.date
						}
					], []);
					this.originalRows = JSON.stringify(this.editRows);
					this.multiEdit = this.editRows.length > 1;
				}

				this.toReceive_idToReceive = this.transactionDocument.idToReceive;
				this.toReceive_idSchedulingRecurring = this.transactionDocument.idSchedulingRecurring;
				this.toReceive_comments = this.transactionDocument.comments || "";
				this.toReceive_idCategory = this.transactionDocument.idCategory;
				this.toReceive_idCustomer = this.transactionDocument.idCustomer;
				this.toReceive_date = new Date(this.transactionDocument.transactionDate);
				this.toReceive_date_receive = this.transactionDocument.scheduleDate ? new Date(this.transactionDocument.scheduleDate) : null;
				this.toReceive_amount_string = numberFormatted(this.transactionDocument.transactionAmount);
				this.toReceive_amount = this.transactionDocument.transactionAmount;
				this.toReceive_idToReceiveDocument = this.transactionDocument.idToReceiveDocument;
				this.editing = true;
				this.disableAmount = this.transactionDocument.status === "PAID";
				this.toReceive_sendLatePaymentMessage = this.transactionDocument.sendLatePaymentMessage;
				this.newCategory = {
					id: this.transactionDocument.idCategory,
					description: this.transactionDocument.categoryName
				};
				this.newCustomer = {
					id: this.transactionDocument.idCustomer,
					description: this.transactionDocument.accountName
				};
			}
		},

		methods: {
			setNewToReceiveDataInstallments (data) {
				this.toReceivePayloadObject = {
					toReceiveDataInstallments: data.toReceiveDataInstallments,
					sendLatePaymentMessage: data.sendMsg || false,
					amount: data.outstandingBalance,
					interval: parseInt(data.day),
					dayOfMonth: data.dayOfMonth

				};
			},

			setNewAmount (value) {
				this.updateInstallments = false;
			},

			validateInstallments (valid) {
				this.errorInstallments = valid;
				this.$emit("invalidForm", Boolean(valid || this.invalidForm));
			},

			formatter (date) {
				return dayjs(date).locale("pt-br").format("D [de] MMMM [de] YYYY");
			},

			async save () {
				if (!this.multiEdit) {
					this.toReceivePayloadObject.idCustomer = this.toReceive_idCustomer;
					this.toReceivePayloadObject.comments = this.toReceive_comments;
					this.toReceivePayloadObject.idCategory = this.toReceive_idCategory;
					this.toReceivePayloadObject.date = this.toReceive_date;
					this.toReceivePayloadObject.idToReceive = this.toReceive_idToReceive;
					this.toReceivePayloadObject.idToReceiveDocument = this.toReceive_idToReceiveDocument;
					this.toReceivePayloadObject.toReceiveDate = this.toReceive_date_receive;
					this.toReceivePayloadObject.isSchedulingRecurring = this.isSchedulingRecurring;
					this.toReceivePayloadObject.idSchedulingRecurring = this.toReceive_idSchedulingRecurring;
				}

				this.saving = true;
				const payload = this.toReceivePayloadObject;

				const config = {
					timeout: 2000,
					showProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true
				};

				this.$snotify.async("Aguarde...", "Salvando", async () => {
					try {
						this.saving = true;
						if (payload.isSchedulingRecurring) {
							if (payload.idSchedulingRecurring) {
								await this.schedulingRecurringService.updateSchedulingRecurring({payload});
							} else {
								payload.transactionType = "TORECEIVE";
								payload.status = "ACTIVE";
								await this.schedulingRecurringService.createSchedulingRecurring({payload});
							}

						} else if (this.multiEdit) {
							if (payload.length)
								await this.toReceiveService.updateMultiRecords({payload});

						} else if (payload.idToReceive) {
							await this.toReceiveService.updateToReceive({payload});
						} else {
							payload.transactionType = "TORECEIVE";
							payload.status = "ACTIVE";
							await this.toReceiveService.createToReceive({payload});
						}

						this.clearModal();
						this.$emit("saved", true);
						this.saving = false;

						return {
							title: "Sucesso!",
							body: "Transação salva com sucesso.",
							config
						};
					} catch (error) {
						this.$emit("saved", false);
						this.saving = false;
						const msgError = error.response.data.message || "Erro ao tentar salvar a Transação!";
						throw {
							title: "Falha!",
							body: msgError,
							config
						};
					}
				});
			},

			clearModal () {
				this.toReceive_idToReceive = null;
				this.toReceive_comments = "";
				this.toReceive_reference = "";
				this.toReceive_idCategory = null;
				this.toReceive_idAccountExpense = null;
				this.toReceive_date = new Date();
				this.toReceive_amount_string = "0,00";
				this.toReceive_amount = 0;
				this.toReceive_idCustomer = null;
				this.toReceive_date_receive = !this.isSchedulingRecurring ? new Date() : null;
				this.toReceive_sendLatePaymentMessage = false;
				this.toReceive_idToReceiveDocument = null;
				this.saving = false;
				this.editing = false;
				this.invalidForm = true;
				this.disableAmount = false;
				this.toReceivePayloadObject = {};
				this.multiEdit = false;
				this.updateInstallments = true;
				this.errorInstallments = true;

				this.clearSelect = !this.clearSelect;

				this.$emit("clearedFields", true);
			},

			validateState (ref) {
				this.invalidForm = hasFieldsWithErrors(this.veeFields) || this.invalidSearch.customer || this.invalidSearch.category;
				this.$emit("invalidForm", Boolean(this.errorInstallments || this.invalidForm));
				if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated))
					return !this.veeErrors.has(ref);

				return null;
			},

			showCustomer () {
				this.modalCustomer = true;
			},

			closeCustomer (cancelled) {
				if (cancelled) {
					this.nameCustomer = "";
				}

				this.modalCustomer = false;
			},

			setCustomer (newCustomer) {
				this.newCustomer = {
					id: newCustomer[0].idCustomer,
					description: newCustomer[0].description
				};
			},

			changeSelect (option) {
				const { value, text, fatherComponent } = option;
				if (value) {
					if (fatherComponent === "customer") {
						this.toReceive_idCustomer = value;
						this.nameCustomer = text;
					} else {
						this.toReceive_idCategory = value;
						this.nameCategory = text;
					}
				} else {
					if (fatherComponent === "customer") {
						this.nameCustomer = text;
						this.showCustomer();
					} else {
						this.nameCategory = text;
						this.showCategory();
					}
				}
			},

			showCategory () {
				this.modalCategory = true;
			},

			closeCategory (cancelled) {
				if (cancelled) {
					this.nameCategory = "";
				}

				this.modalCategory = false;
			},

			setCategory (newCategoryExpense) {
				this.newCategory = {
					id: newCategoryExpense[0].idCategoryExpense,
					description: newCategoryExpense[0].description
				};
				// Verificar rules of record
				if (newCategoryExpense[0].inactive || !newCategoryExpense[0].income) {
					this.newCategory.notPermited = true;
				}
			},

			validateOptionSearch (validateSearch) {
				this.invalidSearch[validateSearch.fatherComponent] = validateSearch.invalidSearch;
			},

			handleVisibleSuggestion (handleSuggestion) {
				if (handleSuggestion.visibleSuggestion) {
					const visibleSuggestionKeys = Object.keys(this.visibleSuggestion);
					visibleSuggestionKeys.forEach((vsk) => {
						if (vsk === handleSuggestion.name) {
							this.visibleSuggestion[vsk] = handleSuggestion.visibleSuggestion;
						} else {
							this.visibleSuggestion[vsk] = false;
						}
					});
				} else {
					this.visibleSuggestion[handleSuggestion.name] = handleSuggestion.visibleSuggestion;
				}
			},

			isModifiedDate (date1, date2) {
				return (
					date1.getFullYear() === date2.getFullYear() &&
					date1.getMonth() === date2.getMonth() &&
					date1.getDate() === date2.getDate()
				);
			},

			setDataMultiEdit (data) {
				const { dataEdited, sendMsg } = data;
				const original = this.originalRows ? JSON.parse(this.originalRows) : null;
				const modifiedRows = [];
				dataEdited.forEach((row, idx) => {
					const haveAlter = row.paymentDate !== original[idx].paymentDate
						|| row.amount !== original[idx].amount
						|| row.reference !== original[idx].reference
						|| row.comments !== this.toReceive_comments
						|| row.idCustomer !== this.toReceive_idCustomer
						|| row.idCategory !== this.toReceive_idCategory
						|| sendMsg !== this.toReceive_sendLatePaymentMessage
						|| !this.isModifiedDate(new Date(row.date), new Date(this.toReceive_date));

					if (haveAlter) {
						const modifiedrow = {
							idToReceive: row.idToReceive
						};
						if (row.paymentDate !== original[idx].paymentDate) {
							const dateArray = row.paymentDate.split("-");
							const date = new Date(original[idx].fullDate);
							date.setFullYear(dateArray[2]);
							date.setMonth(dateArray[1] - 1);
							date.setDate(dateArray[0]);
							modifiedrow.toReceiveDate = date;
						}

						if (row.amount !== original[idx].amount)
							modifiedrow.amount = row.amount.replace(".", "").replace(",", ".");

						if (row.reference !== original[idx].reference)
							modifiedrow.reference = row.reference;

						if (row.comments !== this.toReceive_comments)
							modifiedrow.comments = this.toReceive_comments;

						if (row.idCustomer !== this.toReceive_idCustomer)
							modifiedrow.idCustomer = this.toReceive_idCustomer;

						if (row.idCategoryExpense !== this.toReceive_idCategory)
							modifiedrow.idCategory = this.toReceive_idCategory;

						if (sendMsg !== this.toReceive_sendLatePaymentMessage)
							modifiedrow.sendLatePaymentMessage = sendMsg;

						if (!this.isModifiedDate(new Date(row.date), new Date(this.toReceive_date))) {
							modifiedrow.date = this.toReceive_date;
						}

						modifiedRows.push(modifiedrow);
					}

				});

				this.toReceivePayloadObject = modifiedRows;
			},

			changeToggle (key) {
				this[key] = !this[key];
				if (key === "isSchedulingRecurring") {
					if (this[key]) {
						this.toReceive_date_receive = null;
					} else {
						if (this.toReceive_idAccountExpense) {
							this.toReceive_date = new Date();
							this.toReceive_date_receive = new Date();
						} else {
							this.toReceive_date_receive = new Date(this.toReceive_date);
						}
					}
				}
			},

			clearData (key) {
				this[key] = null;
			},

			setDataRecurrent (data) {
				this.toReceivePayloadObject = {
					...data
				};
			}
		}
	};

</script>

<style scoped>
	.icon-delete {
		margin-top: -3px;
		margin-left: 3px;
		display: flex;
		justify-content: center;
		background-color: red;
		color: white;
		padding: 2px;
	}
</style>